import { useCallback, useContext, useEffect, useState } from "react";
import { logout } from "services/auth";
import { checkUIVersion } from "services/common";
import { AppContext } from "context/AppProvider";

const UPDATE_INTERVAL = 1000 * 60 * 60;
// const UPDATE_INTERVAL = 10000;

function useCheckVersionUpdates(params?: { autoCheckInIntervals?: boolean }) {
  const { autoCheckInIntervals = true } = params || {};
  const { setUiVersion, uiVersion: existingUiVersion } = useContext(AppContext);
  const [newUiVersion, setNewUiVersion] = useState<number | null>(null);

  const fetchLatestVersion = useCallback(async () => {
    const response = await checkUIVersion();

    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { version, maintenance_status } = response?.success || {};
    if (!version || !maintenance_status) {
      return;
    }

    if (maintenance_status === "true") {
      logout();
      return;
    }

    if (version) {
      setNewUiVersion(version);
    }
  }, []);

  useEffect(() => {
    if (!existingUiVersion && newUiVersion) {
      setUiVersion(newUiVersion);
    } else if (
      existingUiVersion &&
      newUiVersion &&
      existingUiVersion !== newUiVersion
    ) {
      window.location.reload();
    }
  }, [newUiVersion, setUiVersion, existingUiVersion]);

  useEffect(() => {
    fetchLatestVersion();
    if (autoCheckInIntervals) {
      const interval = setInterval(fetchLatestVersion, UPDATE_INTERVAL);
      return () => clearInterval(interval);
    }
    return () => {};
  }, [fetchLatestVersion, autoCheckInIntervals]);
}

export default useCheckVersionUpdates;
